module.exports = __webpack_public_path__ + "img/Wp_2062.636793a0.png";